import { ChevronDown } from 'lucide-react';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';

interface FilterSectionProps {
  title: string;
  isOpen: boolean;
  onToggle: () => void;
  children: React.ReactNode;
}

export function FilterSection({ title, isOpen, onToggle, children }: FilterSectionProps) {
  return (
    <Collapsible open={isOpen} onOpenChange={onToggle} className="mt-4 mb-2">
      <CollapsibleTrigger className="w-full flex items-center gap-3 px-2 py-1.5 rounded-xl border border-slate-200 dark:border-gray-600/50 transition-all duration-300 hover:shadow-lg hover:shadow-blue-500/10 dark:hover:shadow-blue-400/20 hover:border-blue-300 dark:hover:border-blue-500/50 section-header bg-gradient-to-r from-slate-50 to-slate-100 dark:from-gray-800/50 dark:to-gray-700/50">
        <div
          className={`chevron-container flex items-center justify-center w-6 h-6 rounded-full bg-white dark:bg-gray-700/80 shadow-sm transition-all duration-300 ${
            isOpen ? '' : 'rotate-180'
          }`}
        >
          <ChevronDown className="w-4 h-4 text-slate-600 dark:text-gray-300 transition-colors duration-300" />
        </div>
        <div className="text-sm font-semibold text-slate-700 dark:text-slate-300 transition-colors duration-300">
          {title}
        </div>
      </CollapsibleTrigger>

      <CollapsibleContent className="mt-3 overflow-hidden pr-0 pl-0 data-[state=closed]:animate-collapsible-up data-[state=open]:animate-collapsible-down">
        {children}
      </CollapsibleContent>
    </Collapsible>
  );
}
